import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function XaritadagiManzilimiz() {
  return <section data-section-id="223598" id="our-home-ground" className="bg-background text-foreground relative w-full h-[600px] md:h-[700px] overflow-hidden border-t-2 border-primary">
      {}
      <div className="absolute inset-0 w-full h-full bg-muted">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3457.444444444444!2d138.5444444444444!3d-34.93333333333333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ab0cf3333333333%3A0x3333333333333333!2sJack%20Smith%20Park!5e0!3m2!1sen!2sau!4v1680000000000!5m2!1sen!2sau" className="w-full h-full border-0 filter grayscale invert contrast-125 opacity-90" allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="WT Birkalla Home Ground Map"></iframe>
        {}
        <div className="absolute inset-0 bg-background/40 pointer-events-none"></div>
      </div>

      {}
      <div className="absolute top-8 left-4 right-4 md:top-1/2 md:-translate-y-1/2 md:left-12 md:right-auto md:w-[420px] z-10">
        <Card className="bg-card/90 backdrop-blur-xl border-primary/30 shadow-3xl rounded-sm border-t-4 border-t-primary">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-3xl font-extrabold tracking-tighter uppercase text-foreground">
              Our Home Ground
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-sm shrink-0 mt-0.5">
                <MapPin className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-bold text-primary text-xs uppercase tracking-widest mb-1">
                  Location
                </h4>
                <p className="text-foreground font-medium leading-relaxed">
                  Jack Smith Park, West Beach SA 5024
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-sm shrink-0 mt-0.5">
                <Clock className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-bold text-primary text-xs uppercase tracking-widest mb-1">
                  Club Hours
                </h4>
                <p className="text-foreground font-medium leading-relaxed">
                  Training: Mon - Fri 5:00 PM - 9:00 PM
                  <br />
                  Match Days: Sat - Sun 8:00 AM - 6:00 PM
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-sm shrink-0 mt-0.5">
                <Phone className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-bold text-primary text-xs uppercase tracking-widest mb-1">
                  Contact
                </h4>
                <p className="text-foreground font-medium leading-relaxed">
                  (08) 8353 0000
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-2 rounded-sm shrink-0 mt-0.5">
                <Mail className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h4 className="font-default font-bold text-primary text-xs uppercase tracking-widest mb-1">
                  Enquiries
                </h4>
                <p className="text-foreground font-medium leading-relaxed">
                  admin@wtbirkalla.com.au
                </p>
              </div>
            </div>

            <div className="pt-2">
              <Button className="w-full bg-primary text-primary-foreground font-bold uppercase tracking-wider rounded-sm hover:bg-primary/90 transition-all" size="lg">
                Get Directions
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}